module.exports = __webpack_public_path__ + "img/xiexiaoming_pink.83a64061.png";